export const URL_CONSTANTS: any = {
    GET_FAVORITE_PDC: '/api/v1/pdc/favorite-pdc/query',
    CREATE_FAVORITE_PDC: '/api/v1/pdc/favorite-pdc/create',
    REMOVE_FAVORITE_PDC: "/api/v1/pdc/favorite-pdc/remove",
    GET_CUSTOM_PDC: '/api/v1/pdc/custom-pdc/query',
    CREATE_CUSTOM_PDC: '/api/v1/pdc/custom-pdc/create',
    REMOVE_CUSTOM_PDC: "/api/v1/pdc/custom-pdc/remove",
    UPDATE_CUSTOM_PDC: "/api/v1/pdc/custom-pdc/update",
    CATEGORIES: '/api/v1/pdc/read/category'
} 